import { Form, Input } from 'antd';
import { useEffect, useMemo } from 'react';
import { DetailInbound } from '../../Inbound/Interface';

function CheckPoint({ data, edit }: { data?: DetailInbound; edit?: boolean }) {
  const [form] = Form.useForm();
  const isEdit = edit ? false : true;
  const defaultValue = useMemo(() => {
    return {
      checkPoint: data ? data?.checkPoint : ''
    };
  }, [data]);
  useEffect(() => {
    form.setFieldsValue(defaultValue);
  }, [form, defaultValue]);
  return (
    <>
      <Form
        form={form}
        layout="vertical"
        style={{ width: '100%' }}
        initialValues={{
          checkPoint: defaultValue.checkPoint
        }}
      >
        <div
          className="wrapTitle"
          style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between'
          }}
        >
          <p>Check Point</p>
        </div>
        <Form.Item name="checkPoint">
          <Input.TextArea
            disabled={isEdit}
            style={{ resize: 'none' }}
            rows={3}
            className="inputRadious"
          />
        </Form.Item>
      </Form>
    </>
  );
}

export default CheckPoint;
